import React from 'react'
import { Card, CardMedia, Hidden, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'


import { projects } from '../content/projects'


const styles = theme => ({
  projects: {
    margin: '5vw',
    width: '90vw',
    padding: theme.spacing(3, 0),
    '@media (min-width:1000px)': {
      padding: theme.spacing(4, 0),
      width:'90vw',
    },
    '@media (min-width:1200px)': {
      padding: theme.spacing(5, 0),
      width: '80vw',
    },
    '@media (min-width:1400px)': {
      padding: theme.spacing(5, 0),
      width: '70vw',
    },
    '@media (min-width:1600px)': {
      padding: theme.spacing(5, 0),
      width: '60vw',
    },
    '@media (min-width:1750px)': {
      padding: theme.spacing(5, 0),
      width: '50vw',
    },
  },
  title: {
    color: 'white',
    margin: theme.spacing(3, 0, 10, 0),
  },
  // Flex row (media | body). No floats — the media column stretches to the
  // full card height and the body owns its own padding, so nothing spills
  // past the card's rounded corners.
  project: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(8, 0),
    overflow: 'hidden',
    '@media (min-width:1200px)': {
      flexDirection: 'row',
    },
  },
  cover: {
    position: 'relative',
    width: '100%',
    height: '44vw',
    flexShrink: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    '@media (min-width:1200px)': {
      width: '15vw',
      height: 'auto',        // stretches to the row (card) height
      minHeight: '25vh',
    },
    '& h4': {
      position: 'absolute',
      bottom: theme.spacing(1),
      left: 0,
      color: 'whitesmoke',
      fontWeight: '900',
      background: '#111',
      padding: theme.spacing(1),
    },
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    padding: theme.spacing(3),
  },
  content: {
    flex: 1,
    '& h6': {
      color: '#111',
      marginBottom: theme.spacing(1),
    },
    '& p': {
      color: '#111',
    },
  },
  sponsor: {
    marginTop: theme.spacing(2),
    textAlign: 'right',
    color: '#333',
  },
})


class Projects extends React.Component {

  renderCard(project) {
    const {classes} = this.props
    return (
      <Card className={classes.project} key={project.name}>
        <CardMedia className={classes.cover}
          image={project.image}
          title={project.name}>
          <Hidden mdDown>
            <Typography component="h4" variant="h4">
              {project.name}
            </Typography>
          </Hidden>
        </CardMedia>
        <div className={classes.body}>
          <div className={classes.content}>
            <Hidden lgUp>
              <Typography component="h5" variant="h5">
                <b>{project.name}</b>
              </Typography>
            </Hidden>
            <Typography component="h6" variant="h6">
              <b>{project.subtitle}</b>
            </Typography>
            <Typography component="p" variant="body1">
              {project.description}
            </Typography>
          </div>
          <Typography component="p" variant="body2" className={classes.sponsor}>
            <em>Sponsor/Program:</em> {project.sponsor_line}
          </Typography>
        </div>
      </Card>
    )
  }

  render() {
    const {classes} = this.props
    const active = projects.filter(p => p.active)
    const past = projects.filter(p => !p.active)
    return (
      <div id="projects" className={classes.projects}>
        <Typography
          component="h4"
          variant="h4"
          className={classes.title}>
          Current Research Projects
        </Typography>
        {active.map(p => this.renderCard(p))}
        <Typography
          component="h4"
          variant="h4"
          className={classes.title}>
          Past Projects
        </Typography>
        {past.map(p => this.renderCard(p))}
      </div>
    )
  }
}


export default withStyles(styles)(Projects)
